import React from 'react';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { renderSpinner } from '../../../lib/UiUtils';
import { log } from "../../../lib/Logger";
import {
  PROJECT_INTERNAL_NAME,
} from '../../../lib/Constants';
import Confetti from 'react-confetti';
import {getCenterCoordinates, getCenterOffset} from '../../../lib/GeneralUtils';
import WordPool from "../../../lib/WordPool";
import {CENTER_CELL_TEXT} from "../modules/board";
import ReactModal from 'react-modal';

const LOCAL_STORAGE_KEY_CELL_WORDS = `${PROJECT_INTERNAL_NAME}.word_list`;
const LOCAL_STORAGE_KEY_SELECTED_CELLS = `${PROJECT_INTERNAL_NAME}.selected_cells`;
const LOCAL_STORAGE_KEY_HAS_SENT_EMAIL = `${PROJECT_INTERNAL_NAME}.has_sent_email`;

class Board extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: false
        };

        this.handleCellClick = this.handleCellClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        let {
            wordPool,
            init,
            boardSize: {
                x: boardCellsX,
                y: boardCellsY,
            },
        } = this.props;
        if (wordPool.length === 0) {
            log(`Word pool empty, initializing app...`);
            let {
                previousWordCells,
                selected,
                hasSentNotification,
            } = this.getLocalStorageProperties();

            init(WordPool, previousWordCells, selected, hasSentNotification);
        }
    }

    getLocalStorageProperties() {
        let localStorage = window.localStorage;
        let previousWordCellsString = localStorage.getItem(LOCAL_STORAGE_KEY_CELL_WORDS) || '[]';
        let previousWordCells = JSON.parse(previousWordCellsString);
        let selectedString = localStorage.getItem(LOCAL_STORAGE_KEY_SELECTED_CELLS) || '[]';
        let selected = JSON.parse(selectedString);
        let hasSentNotification = Boolean(localStorage.getItem(LOCAL_STORAGE_KEY_HAS_SENT_EMAIL));

        return {
            previousWordCells,
            selected,
            hasSentNotification,
        };
    }

    closeModal() {
        this.setState({
            modalIsOpen: false
        });
    }

    handleCellClick(event) {
        let {
            toggleSquare,
            boardSize: {
                x: boardCellsX,
                y: boardCellsY,
            },
        } = this.props;
        let attributes = event.currentTarget.attributes;
        let x = parseInt(attributes['data-x'].value, 10);
        let y = parseInt(attributes['data-y'].value, 10);
        let [centerX, centerY] = getCenterCoordinates(boardCellsX, boardCellsY);
        // Ignore clicks on the free space
        if (x === centerX && y === centerY) {
            return;
        }
        console.log(`Clicked x:${x}, y:${y}`);
        toggleSquare(x, y);
    }

    componentDidUpdate(prevProps, prevState) {
        let {
            selectedCells: newSelectedCells,
            boardSize: {
                x: boardCellsX,
                y: boardCellsY,
            },
            cellWords: newCellWords,
            hasBingoed: newBingo,
        } = this.props;
        let {
            selectedCells: oldSelectedCells,
            cellWords: oldCellWords,
            hasBingoed: oldBingo,
        } = prevProps;

        // If we've just bingoed and haven't already sent a notification, display the congrats modal
        if (!oldBingo && newBingo && !Boolean(window.localStorage.getItem(LOCAL_STORAGE_KEY_HAS_SENT_EMAIL))) {
            this.setState({
                modalIsOpen: true
            });
        }

        if (newCellWords.length === 0) {
            return;
        }

        // If the word pool has been populated, persist it
        if (newCellWords.length !== oldCellWords.length) {
            console.log(`Updated word list, writing to local storage`);
            window.localStorage.setItem(LOCAL_STORAGE_KEY_CELL_WORDS, JSON.stringify(newCellWords));
        }

        if (newSelectedCells.length !== boardCellsY || newSelectedCells[0].length !== boardCellsX) {
            return;
        }

        let isSelectionUpdated = newSelectedCells.some((newCellRow, y) => {
            return newCellRow.some((newCell, x) => {
                if (oldSelectedCells.hasOwnProperty(y) && oldSelectedCells[y].hasOwnProperty(x)) {
                    let oldCell = oldSelectedCells[y][x];
                    return oldCell !== newCell;
                } else {
                    return false;
                }
            });
        });

        if (isSelectionUpdated) {
            console.log(`Updated selected cells, writing to local storage`);
            window.localStorage.setItem(LOCAL_STORAGE_KEY_SELECTED_CELLS, JSON.stringify(newSelectedCells));
        }
    }

    render() {
        let {
            selectedCells,
            cellWords,
            boardSize: {
                x: boardCellsX,
                y: boardCellsY,
            },
            wordPool,
            bingos,
            hasBingoed,
        } = this.props;

        if (wordPool.length === 0) {
            return <div>
                {renderSpinner('fa-5x')}
            </div>;
        }

        let center = getCenterCoordinates(boardCellsX, boardCellsY);

        return <div className='full-size'>
            <div className='header-container'>
                {this.renderHeader(boardCellsX)}
            </div>
            <div className="full-size">
                {this.renderConfetti(hasBingoed && !this.state.modalIsOpen, this.props.size)}
                {this.renderCompletionModal(hasBingoed)}
                <div className="grid-container full-size" style={{
                    gridTemplateColumns: `repeat(${boardCellsX}, 1fr)`,
                    gridTemplateRows: `repeat(${boardCellsY}, 1fr)`,
                }}>
                    {[...Array(boardCellsY)].map((_, y) => {
                        return [...Array(boardCellsX)].map((_, x) => {
                            return <div key={`cell-container-${x}-${y}`}
                                        className={`cell-container ` +
                                            `${bingos[y][x] ? 'bingoed ' : ' '}` +
                                            `${y === boardCellsY - 1 ? 'bottom-row ' : ' '}` +
                                            `${x === 0 ? 'first-column ' : ' '}` +
                                            `${x === boardCellsX - 1 ? 'last-column ' : ' '}`}
                                        onClick={this.handleCellClick} style={{
                                gridColumnStart: x,
                                gridRowStart: y,
                            }} data-x={x} data-y={y}>
                                {this.renderCellContent(x, y, cellWords, selectedCells[y][x], center)}
                            </div>;
                        });
                    })}
                </div>
            </div>
        </div>;
    }

    renderHeader(numberOfColumns) {
        return <div className='header-grid-container' style={{gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)`}}>
            <div className='cell-container top-row first-column'>
                <p className='cell-text'>T</p>
            </div>
            <div className='cell-container top-row'>
                <p className='cell-text'>P</p>
            </div>
            <div className='cell-container top-row'>
                <img className='sfdc-logo' src='sfdc_logo.svg' alt='Salesforce logo'/>
            </div>
            <div className='cell-container top-row'>
                <p className='cell-text'>I</p>
            </div>
            <div className='cell-container top-row last-column'>
                <p className='cell-text'>L</p>
            </div>
        </div>;
    }

    renderCellContent(x, y, cellWords, isSelected, center) {
        let [centerX, centerY] = center;
        if (x === centerX && y === centerY) {
            return <div className='center-cell'>
              <p id='center-cell-text' className='cell-text' key='center-cell'>{CENTER_CELL_TEXT}</p>
            </div>;
        } else if (isSelected) {
            return <div className="selected-cell">
                {this.renderCellText(x, y, cellWords)}
            </div>;
        } else {
            return this.renderCellText(x, y, cellWords);
        }
    }

    renderCellText(x, y, cellWords) {
        return <p key={`cell-text-${x}-${y}`} className="cell-text">{cellWords[y][x]}</p>;
    }

    renderConfetti(showConfetti, size) {
        if (!showConfetti) {
            return null;
        }
        return <Confetti {...size} />;
    }

    renderCompletionModal(hasBingoed) {
        if (!hasBingoed) {
            return null;
        }

        return <ReactModal
            className='bingo-modal'
            isOpen={this.state.modalIsOpen}
            // onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            // style={customStyles}
            contentLabel="Example Modal"
        >

            <h2>Congrats!</h2>
            <p>Please email a screenshot of your completed bingo card to tmponboarding@salesforce.com to get your swag!</p>
            <button onClick={this.closeModal}>Got it!</button>
        </ReactModal>;
    }
}

Board.propTypes = {
    // inputCategory: PropTypes.func.isRequired,
    // selectedCategory: PropTypes.number.isRequired,
};

export default Board;



// WEBPACK FOOTER //
// ./src/routes/Board/components/Board.js